export default __webpack_public_path__ + "static/media/s8-bg.c1cc2219.svg";